"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedDocsModal = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const MiniTitle_1 = require("@jsonjoy.com/ui/lib/3-list-item/MiniTitle");
const Separator_1 = require("@jsonjoy.com/ui/lib/3-list-item/Separator");
const Space_1 = require("@jsonjoy.com/ui/lib/3-list-item/Space");
const TextBlock_1 = require("@jsonjoy.com/ui/lib/5-block/TextBlock");
const Iconista_1 = require("@jsonjoy.com/ui/lib/icons/Iconista");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const ModalOverlay_1 = require("../ModalOverlay");
const context_2 = require("../../context");
const wrapperClass = (0, nano_theme_1.rule)({
    bxz: 'border-box',
    w: '100%',
    pd: '40px 40px 56px',
});
const gridClass = (0, nano_theme_1.rule)({
    d: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '40px 56px',
    maxW: '1111px',
    mr: 'auto',
});
const sectionClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'column',
    miw: 0,
    breakInside: 'avoid',
});
const titleRowClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    gap: '8px',
    mar: '0 0 10px',
});
const introClass = (0, nano_theme_1.rule)({
    fz: '13.5px',
    lh: 1.55,
    mar: '12px 0 16px',
});
const linksClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    gap: '14px',
    fw: 'wrap',
    mar: '14px 0 0',
    fz: '13px',
});
const linkClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    gap: '6px',
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
});
const ELEMENT_SNIPPET = `<mu-txt style="height:500px">
  Hello! Edit this text right in the page.
</mu-txt>
<script src="//cdn.jsdelivr.net/npm/mutxt-element"></script>`;
const REACT_SNIPPET = `import {MuTxt} from 'mutxt-react';

export const App = () =>
  <MuTxt autoFocus placeholder="Start typing…" />;`;
const Section = ({ icon, title, intro, snippet, lang, links }) => {
    const styles = (0, context_1.useStyles)();
    return (React.createElement("section", { className: sectionClass },
        React.createElement("div", { className: titleRowClass },
            icon,
            React.createElement(MiniTitle_1.MiniTitle, { component: "div", contrast: true }, title)),
        React.createElement(Separator_1.Separator, null),
        React.createElement(Space_1.Space, null),
        React.createElement("div", { className: introClass, style: { color: styles.g(0.25, 0.85) } }, intro),
        React.createElement(TextBlock_1.TextBlock, { src: snippet, lang: lang, select: true, compact: true }),
        React.createElement("div", { className: linksClass, style: { color: styles.g(0.3, 0.8) } }, links.map((link) => (React.createElement("a", { key: link.href, className: linkClass, href: link.href, target: "_blank", rel: "noreferrer noopener", style: { color: styles.g(0.2, 0.95) } },
            link.icon,
            link.label))))));
};
const ExternalIcon = () => (React.createElement(Iconista_1.Iconista, { set: "tabler", icon: "external-link", width: 14, height: 14, style: { opacity: 0.7 } }));
const EmbedDocsModal = () => {
    const mutxt = (0, context_2.useMuTxt)();
    const open = mutxt.embedDocsOpen.use();
    const close = React.useCallback(() => mutxt.embedDocsOpen.set(false), [mutxt]);
    return (React.createElement(ModalOverlay_1.ModalOverlay, { open: open, title: "Embed this editor", onClose: close },
        React.createElement("div", { className: wrapperClass },
            React.createElement("div", { className: gridClass },
                React.createElement(Section, { icon: React.createElement(Iconista_1.Iconista, { set: "simple", icon: "html5", width: 18, height: 18 }), title: "HTML \u2014 <mu-txt> custom element", intro: React.createElement(React.Fragment, null,
                        "A drop-in web component. Works in any HTML page \u2014 no build step required. Children seed the document; children content can be plain text, Markdown, or Slate JSON via the ",
                        React.createElement("code", null, "format"),
                        " attribute."), snippet: ELEMENT_SNIPPET, lang: "html", links: [
                        {
                            label: 'mutxt-element on npm',
                            href: 'https://www.npmjs.com/package/mutxt-element',
                            icon: React.createElement(ExternalIcon, null),
                        },
                        {
                            label: 'README & docs',
                            href: 'https://github.com/streamich/json-joy/tree/master/packages/mutxt-element',
                            icon: React.createElement(ExternalIcon, null),
                        },
                    ] }),
                React.createElement(Section, { icon: React.createElement(Iconista_1.Iconista, { set: "simple", icon: "react", width: 18, height: 18 }), title: "React \u2014 <mutxt> component", intro: React.createElement(React.Fragment, null,
                        "Batteries-included React component for tighter integration \u2014 seed from Slate JSON, hand in a Peritext-backed ",
                        React.createElement("code", null, "json-joy"),
                        " model for collaboration, and wire up your own presence manager."), snippet: REACT_SNIPPET, lang: "jsx", links: [
                        {
                            label: 'mutxt-react on npm',
                            href: 'https://www.npmjs.com/package/mutxt-react',
                            icon: React.createElement(ExternalIcon, null),
                        },
                        {
                            label: 'README & docs',
                            href: 'https://github.com/streamich/json-joy/tree/master/packages/mutxt-react',
                            icon: React.createElement(ExternalIcon, null),
                        },
                    ] })))));
};
exports.EmbedDocsModal = EmbedDocsModal;
